export default __webpack_public_path__ + "262bbd32abfb590a6dd34d5e8fdea3af.png";